import { clubbiStyled } from 'clubbi-ui'

export const Container = clubbiStyled('div')(({ theme }) => ({
  background: '#fff',
  borderRadius: '12px',
  padding: '20px 24px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  border: '1px solid #e5e5e5',
  margin: '0 0 20px 20px',
}))

export const HeaderRow = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
}))

export const Title = clubbiStyled('h2')(({ theme }) => ({
  color: '#04153b',
  fontSize: '22px',
  fontWeight: 'bold',
  margin: 0,
}))

export const Logo = clubbiStyled('img')(({ theme }) => ({
  width: '100px',
  height: '40px',
}))

export const InfoGrid = clubbiStyled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: '24px',
  alignItems: 'start',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}))

export const CustomerBlock = clubbiStyled('div')(({ theme }) => ({
  textAlign: 'left',
  h4: {
    margin: 0,
    fontSize: '16px',
    color: '#04153b',
    fontWeight: 'bold',
  },
  p: {
    margin: '4px 0',
    fontSize: '14px',
    color: '#555',
  },
}))

export const OrderBlock = clubbiStyled('div')(({ theme }) => ({
  p: {
    margin: '6px 0',
    fontSize: '14px',
    color: '#04153b',
    display: 'flex',
    gap: '6px',
    alignItems: 'flex-start',

    svg: {
      color: '#8c8c8c',
      width: '16px',
      height: '16px',
      flexShrink: 0,
      marginTop: '3px',
    },
  },
}))

export const OrdersList = clubbiStyled('span')(({ theme }) => ({
  wordBreak: 'break-word',
  textAlign: 'initial',
}))
